import React from 'react'

const AlertTableLoadableComponent = React.lazy(() => import('./AlertTableComponent'))
export {
	AlertTableLoadableComponent
}